const Flutter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="79"
      viewBox="0 0 64 79"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.1391 79L18.6797 57.7627L30.5416 45.7419L63.9994 79H40.1391Z"
        fill="#02539A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4146 57.7791L39.6884 36.5901H63.6036L30.5085 69.5524L18.4146 57.7791Z"
        fill="#45D1FD"
        fillOpacity="0.85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 39.2977L12.0775 51.3192L63.6024 0H39.5629L0 39.2977Z"
        fill="#45D1FD"
      />
    </svg>
  );
};

export default Flutter;
